import { Icon } from "@material-ui/core";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import { withStyles } from "@material-ui/core/styles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import "assets/css/form-auto.css";
import {} from "assets/jss/material-dashboard-react.js";
import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import AssociationList from "components/AssociationList";
import Card from "components/Card/Card.js";
import CardFooter from "components/Card/CardFooter.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CustomTabs from "components/CustomTabs/CustomTabs";
import Form from "components/MuiJsonForm";
import RowGenerateFile from "components/RowGenerateFile";
import axios from "axios";
import PubSub from "pubsub-js";
import queryString from "query-string";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import Actions from "redux/actions";
import {
  accompteColumns,
  appartementColumns,
  clientColumns,
} from "utils/columns";
import fileDialog from "utils/fileDialog";
import { accompteSchema, missionSchema } from "utils/schemas";

class FormEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loading: true, formData: {}, initLoad: true };
    this.dispatch = this.props.dispatch;
    this.isNew = props.match.params.id === "new";
    this.edit = props.match.params.edit ? true : false;
    this.readOnly = !this.isNew && !this.edit;
    this.cancelSources = new Set();
    this.timeouts = new Set();
    this.subs = [];
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
    this.loadData();
  }

  loadData = () => {
    this.isNew = this.props.match.params.id === "new";
    this.edit = this.props.match.params.edit ? true : false;
    this.readOnly = !this.isNew && !this.edit;
    this.cancelAllRequests("MissionEditor remount");
    this.clearTimeouts();
    let actions = [];
    if (!this.state.initLoad)
      this.updateState({ loading: true, formData: {}, initLoad: true });
    const missionSource = this.createCancelSource();
    actions.push(
      this.trackPromise(
        this.dispatch(
          Actions.getMission(this.props.match.params.id, {
            cancelToken: missionSource.token,
          })
        ),
        missionSource
      )
    );

    // On decale les requetes lourdes pour ne pas bloquer l'affichage initial.
    this.addTimeout(() => {
      if (!this._isMounted) return;
      const appartSource = this.createCancelSource();
      this.trackPromise(
        this.dispatch(
          Actions.getAppartements({ cancelToken: appartSource.token })
        ),
        appartSource
      );
      if (!this.isNew) {
        const clientsSource = this.createCancelSource();
        this.trackPromise(
          this.dispatch(Actions.getClients({ cancelToken: clientsSource.token })),
          clientsSource
        );
      } else {
        const missionResetSource = this.createCancelSource();
        this.trackPromise(
          this.dispatch(
            Actions.getMission(undefined, {
              cancelToken: missionResetSource.token,
            })
          ),
          missionResetSource
        );
      }
    }, 500);
    const variablesSource = this.createCancelSource();
    actions.push(
      this.trackPromise(
        this.dispatch(Actions.getVariables({ cancelToken: variablesSource.token })),
        variablesSource
      )
    );
    Promise.all(actions)
      .catch(() => null)
      .finally(() =>
        this.updateState({ loading: false, initLoad: false })
      );
  };

  componentWillUnmount() {
    this._isMounted = false;
    this.clearTimeouts();
    this.cancelAllRequests("MissionEditor unmounted");
    this.unsubscribeAll();
  }

  componentDidUpdate(prevProps, prevState) {
    this.isNew = this.props.match.params.id === "new";
    this.edit = this.props.match.params.edit ? true : false;
    this.readOnly = !this.isNew && !this.edit;
    if (this.props.match.params !== prevProps.match.params) {
      this.loadData();
    }
  }

  updateState = (updater, cb) => {
    if (this._isMounted) {
      this.setState(updater, cb);
    }
  };

  addTimeout = (cb, delay = 0) => {
    const id = setTimeout(() => {
      this.timeouts.delete(id);
      cb();
    }, delay);
    this.timeouts.add(id);
    return id;
  };

  clearTimeouts = () => {
    this.timeouts.forEach((id) => clearTimeout(id));
    this.timeouts.clear();
  };

  createCancelSource = () => {
    const source = axios.CancelToken.source();
    this.cancelSources.add(source);
    return source;
  };

  releaseCancelSource = (source) => {
    if (source && this.cancelSources.has(source)) {
      this.cancelSources.delete(source);
    }
  };

  cancelAllRequests = (reason = "cancel") => {
    this.cancelSources.forEach((source) => {
      try {
        source.cancel(reason);
      } catch (_) {}
    });
    this.cancelSources.clear();
  };

  trackPromise = (promise, source) => {
    if (promise && typeof promise.finally === "function") {
      promise.finally(() => this.releaseCancelSource(source));
    } else {
      this.releaseCancelSource(source);
    }
    return promise;
  };

  unsubscribeAll = () => {
    this.subs.forEach((token) => PubSub.unsubscribe(token));
    this.subs = [];
  };

  onSubmit = (form) => {
    if (this.readOnly) return;
    const body = { ...form.formData.data };
    this.updateState({ loading: true });
    (this.isNew
      ? this.dispatch(Actions.createMission(body))
      : this.dispatch(Actions.setMission(this.props.match.params.id, body))
    ).then((rep) => {
      PubSub.notif({
        txt: this.isNew
          ? "Votre mission à été crée avec succes."
          : "Vos modifications ont été prises en compte.",
        color: "success",
        icon: "save",
      });
      this.updateState({ loading: false });
      if (this.isNew)
        this.props.history.push(
          queryString.parse(this.props.location.search).oncreate ||
            `/missions/${rep.payload.id}`
        );
    });
  };

  render() {
    const c = this.props.classes;
    const mission = this.props.mission || {};
    let rest = mission.valeurTotalMission || 0;
    if (mission && mission.Accomptes) {
      mission.Accomptes.filter((a) => a.regle).forEach(
        (a) => (rest -= a.montant)
      );
    }
    return (
      <div className={c.container}>
        {this.readOnly && (
          <div className="justify-b">
            <Card style={{ width: 220 }}>
              <CardHeader color="warning" stats icon>
                <CardIcon color="warning">
                  <Icon>home</Icon>
                </CardIcon>
                <p className={c.cardCategory}>Appartements</p>
                <h3 className={c.cardTitle}>{mission.nbAppart}</h3>
              </CardHeader>
              <CardFooter stats />
            </Card>
            <Card style={{ width: 240 }}>
              <CardHeader color="success" stats icon>
                <CardIcon color="success">
                  <Icon>euro</Icon>
                </CardIcon>
                <p className={c.cardCategory}>Valeur Totale TTC</p>
                <h3 className={c.cardTitle}>
                  {(mission.valeurTotalMission || 0) + "€"}
                </h3>
              </CardHeader>
              <CardFooter stats style={{ marginTop: 0 }}>
                <div className={c.stats + " fullW  align-c justify-b"}>
                  <p className="no-margin">Valeur Totale HT</p>
                  <h5 className={c.cardTitle}>
                    {Math.round(
                      (mission.valeurTotalMission * 100) /
                        (1 + (mission.tauxTva || 0) / 100)
                    ) /
                      100 +
                      "€"}
                  </h5>
                </div>
              </CardFooter>
              <CardFooter stats style={{ margin: 0 }}></CardFooter>
            </Card>
            <Card style={{ width: 220 }}>
              <CardHeader color="danger" stats icon>
                <CardIcon color="danger">
                  <Icon>account_balance_wallet</Icon>
                </CardIcon>
                <p className={c.cardCategory}>Reste à payer TTC</p>
                <h3 className={c.cardTitle}>{rest + "€"}</h3>
              </CardHeader>
              <CardFooter stats />
            </Card>
          </div>
        )}
        <CustomTabs
          initTab={queryString.parse(this.props.location.search).tab}
          title={
            this.state.loading
              ? ""
              : (mission ? "" : "Nouvelle Mission").toUpperCase()
          }
          headerColor="info"
          rigthBtn={
            !this.isNew && {
              display: !this.edit,
              icon: "create",
              onClick: (_) =>
                this.props.history.push(this.props.match.url + "/edit"),
            }
          }
          tabs={[
            {
              tabName: "Details",
              tabIcon: "work_outline",
              tabContent: (
                <>
                  <Form
                    {...missionSchema(
                      this.props.mission,
                      this.readOnly,
                      this.isNew,

                      20 && parseInt(20),
                      (formData) => this.updateState({ formData })
                    )}
                    formData={this.state.formData}
                    initLoad={this.state.initLoad}
                    loading={this.state.loading}
                    readOnly={this.readOnly}
                    onSubmit={this.onSubmit}
                    onError={() => null}
                    removeEditOnSubmit
                  />
                </>
              ),
            },
            {
              tabName: "Commanditaires",
              tabIcon: "assignment_ind",
              tabContent: (
                <AssociationList
                  data={(this.props.mission || {}).Clients}
                  columns={clientColumns}
                  noDataTxt="Aucun client assigné."
                  detailTxt="Voir les details du client"
                  onDetails={(o) => this.props.history.push(`/client/${o.id}`)}
                  removeTxt="Retirer le client"
                  onRemove={(clientId) =>
                    this.dispatch(
                      Actions.removeMissionCustomer(
                        this.props.mission.id,
                        clientId
                      )
                    )
                  }
                  onAdd={(clientId) =>
                    this.dispatch(
                      Actions.addMissionCustomer(
                        this.props.mission.id,
                        clientId
                      )
                    )
                  }
                  addTxt="Sélectionner un client"
                  addData={this.props.clients}
                  addColumn={clientColumns}
                  createTxt="Créer un client"
                  onCreate={(_) =>
                    this.props.history.push(
                      `/client/new?oncreate=${window.location.pathname}?tab=1`
                    )
                  }
                />
              ),
            },
            {
              tabName: "Appartement",
              tabIcon: "home",
              tabContent: (
                <AssociationList
                  data={(this.props.mission || {}).Appartements}
                  columns={appartementColumns}
                  noDataTxt="Aucun appartement lié."
                  detailTxt="Voir les details de l'appartement"
                  onDetails={(o) =>
                    this.props.history.push(`/appartements/${o.id}`)
                  }
                  hideHeader={true}
                  removeTxt="Retirer l'appartement"
                  onRemove={(appartId) =>
                    this.dispatch(
                      Actions.removeMissionAppartement(
                        this.props.mission.id,
                        appartId
                      )
                    )
                  }
                  onAdd={(appartId) =>
                    this.dispatch(
                      Actions.addMissionAppartement(
                        this.props.mission.id,
                        appartId
                      )
                    )
                  }
                  addTxt="Sélectionner un appartement"
                  addData={this.props.appartements}
                  addColumn={appartementColumns}
                  createTxt="Créer un appartement"
                  onCreate={(_) =>
                    this.props.history.push(
                      `/appartements/new?oncreate=${window.location.pathname}?tab=2`
                    )
                  }
                />
              ),
            },
            {
              tabName: "Paiements",
              tabIcon: "account_balance",
              tabContent: (
                <AssociationList
                  title={`Paiement${
                    ((this.props.mission || {}).Accomptes || []).length > 1
                      ? "s"
                      : ""
                  }`}
                  data={(this.props.mission || {}).Accomptes || []}
                  columns={accompteColumns}
                  detailPanel={(rd) => (
                    <div style={{ background: "#EEE", padding: 10 }}>
                      <Form
                        {...accompteSchema(
                          rd,
                          this.props.appartements,
                          false,
                          false,
                          (state) =>
                            this.updateState({ ["FormData_" + rd.id]: state })
                        )}
                        formData={this.state["formData_" + rd.id]}
                        onSubmit={({ formData: { data } }) =>
                          this.dispatch(Actions.setAccompte(rd.id, data)).then((_) =>
                            this.dispatch(
                              Actions.getMission(this.props.match.params.id)
                            )
                          )
                        }
                        onError={() => null}
                      />
                    </div>
                  )}
                  onTopRightButton={(close) => (
                    <Form
                      style={{ width: "100%" }}
                      {...accompteSchema(
                        {},
                        this.props.appartements,
                        false,
                        true,
                        (state) => this.updateState({ formData_new: state })
                      )}
                      formData={this.state["formData_new"]}
                      onSubmit={({ formData: { data } }) => {
                        this.dispatch(Actions.createAccompte(data)).then((rep) =>
                          this.dispatch(
                            Actions.addMissionAccompte(
                              this.props.match.params.id,
                              rep.payload.id
                            )
                          ).then(close)
                        );
                      }}
                      onError={() => null}
                    />
                  )}
                  topRightButtonTxt="Nouveau paiement"
                  detailTxt="Voir l'appartement concerné"
                  noDataTxt="Aucun paiement."
                  removeTxt="Supprimer le paiement"
                  onRemove={(accompteId) =>
                    this.dispatch(
                      Actions.removeMissionAccompte(
                        this.props.match.params.id,
                        accompteId
                      )
                    )
                  }
                />
              ),
            },
            {
              tabName: "Documents",
              tabIcon: "description",
              tabContent: (
                <>
                  <RowGenerateFile
                    title="Ordre de mission"
                    generateUrl={`Mission/${mission.id}/ordreMission/generate`}
                    generateName={`Mission_non_signée.docx`}
                    uploaded={mission.ordreMission}
                    uploadedName={`Mission_signée.docx`}
                    onUpload={(_) =>
                      fileDialog("ordreMission").then((fd) =>
                        this.dispatch(Actions.setMission(mission.id, fd))
                      )
                    }
                  />
                  {(mission.Clients || []).some((p) => p.Fichiers?.length) && (
                    <ExpansionPanel>
                      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                        <h4>Client</h4>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails className="col">
                        {(mission.Clients || []).map((prop) =>
                          prop.Fichiers.map((file) => (
                            <RowGenerateFile
                              key={file.id}
                              title={`${prop.nom} ${prop.prenom}_${file.nom}`}
                              uploaded={file.url}
                              uploadedName={file.nom + "." + file.extention}
                            />
                          ))
                        )}
                      </ExpansionPanelDetails>
                    </ExpansionPanel>
                  )}
                </>
              ),
            },
          ].filter((t) => !this.isNew || t.tabName === "Details")}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  mission: state.reducer.mission,
  clients: state.reducer.clients,
  variables: state.reducer.variables,
  appartements: state.reducer.appartements,
});
export default withRouter(
  withStyles(styles)(connect(mapStateToProps)(FormEditor))
);
